import {
  FaBox,
  FaCircleCheck,
  FaHeart,
  FaLocationDot,
  FaShieldHalved,
  FaTruckFast,
  FaTriangleExclamation,
} from 'react-icons/fa6'

export default function VaultPanel({ account, ImageComponent, items = [], summary, onSectionChange }) {
  const shipping = account?.shippingProfile || {}
  const Image = ImageComponent || DefaultImage
  const readiness = [
    {
      label: 'Bidder verification',
      value: account?.verifiedBidder ? 'Active' : 'Required',
      note: account?.verifiedBidder ? 'Card on file can place bids.' : 'Save a card before bidding.',
      icon: account?.verifiedBidder ? <FaCircleCheck /> : <FaTriangleExclamation />,
      tone: account?.verifiedBidder ? 'success' : 'danger',
      action: 'payments',
    },
    {
      label: 'Shipping profile',
      value: shipping.ready ? 'Ready' : 'Incomplete',
      note: shipping.ready ? `${shipping.city}, ${shipping.state} ${shipping.postalCode || ''}` : 'Complete profile before checkout.',
      icon: <FaLocationDot />,
      tone: shipping.ready ? 'success' : 'warning',
      action: 'profile',
    },
    {
      label: 'Weekly checkout',
      value: summary?.checkout || 'Friday',
      note: `${summary?.weeklyHold || 0} held items can be combined.`,
      icon: <FaTruckFast />,
      tone: summary?.weeklyHold ? 'warning' : 'neutral',
      action: 'bundle',
    },
  ]

  return (
    <section className="tactical-card obc-vault">
      <div className="obc-dashboard__section-head">
        <div>
          <span />
          <h2>The Vault</h2>
        </div>
        <button type="button" onClick={() => onSectionChange('orders')}>Order History</button>
      </div>

      <div className="obc-vault__hero">
        <div>
          <span className="obc-vault__kicker"><FaShieldHalved /> Collector command vault</span>
          <h3>{account?.name || 'Collector'} inventory, wins, holds, and watched lots</h3>
          <p>Track everything tied to this account from one operational view: unpaid wins, weekly holds, buy-now purchases, leading bids, and watched auction targets.</p>
        </div>
        <div className="obc-vault__value">
          <span>Tracked value</span>
          <strong>{summary?.vaultValue || '$0'}</strong>
          <small>{summary?.totalItems || items.length} vault records</small>
        </div>
      </div>

      <div className="obc-vault__stats">
        <article>
          <FaBox />
          <span>Total records</span>
          <strong>{summary?.totalItems || items.length}</strong>
        </article>
        <article className={summary?.dueNow ? 'is-danger' : undefined}>
          <FaTriangleExclamation />
          <span>Due now</span>
          <strong>{summary?.dueNow || 0}</strong>
        </article>
        <article>
          <FaTruckFast />
          <span>Weekly hold</span>
          <strong>{summary?.weeklyHold || 0}</strong>
        </article>
        <article>
          <FaHeart />
          <span>Watchlist</span>
          <strong>{summary?.watchlist || 0}</strong>
        </article>
      </div>

      <div className="obc-vault__readiness">
        {readiness.map((item) => (
          <button className={`is-${item.tone}`} type="button" onClick={() => onSectionChange(item.action)} key={item.label}>
            {item.icon}
            <span>{item.label}</span>
            <strong>{item.value}</strong>
            <small>{item.note}</small>
          </button>
        ))}
      </div>

      <div className="obc-vault__items">
        {items.map((item) => (
          <article className={`obc-vault__item is-${item.tone}`} key={item.id}>
            <Image src={item.image} alt={item.title} />
            <div>
              <span>{item.lane}</span>
              <h4>{item.title}</h4>
              <p>{item.detail}</p>
              <small>{item.meta}</small>
            </div>
            <div>
              <strong>{item.value}</strong>
              <b>{item.status}</b>
            </div>
          </article>
        ))}
      </div>

      {!items.length ? <p className="obc-dashboard__empty-state">No Vault records yet. Wins, Buy Now purchases, weekly holds, and watched lots will appear here.</p> : null}
    </section>
  )
}

function DefaultImage({ alt, src }) {
  return src ? <img src={src} alt={alt} /> : null
}
